import { NgModule } from '@angular/core';

import { ConnectionTypesSharedModule } from 'app/connection-types/connection-types-shared.module';
import { NoteModule } from 'app/note/note.module';
import { SharedModule } from 'shared/shared.module';
import { HighlightedToplineComponent } from './components/highlighted-topline/highlighted-topline.component';

import { ToplineAddressComponent } from './components/topline-address/topline-address.component';
import { ToplineAgeComponent } from './components/topline-age/topline-age.component';
import { ToplineConnectionComponent } from './components/topline-connection/topline-connection.component';
import { ToplineEmailComponent } from './components/topline-email/topline-email.component';
import { ToplineNoteComponent } from './components/topline-note/topline-note.component';
import { ToplinePhoneComponent } from './components/topline-phone/topline-phone.component';
import { ToplinePreferredLanguageComponent } from './components/topline-preferred-language/topline-preferred-language.component';
import { ToplineSocialComponent } from './components/topline-social/topline-social.component';
import { ToplineTagCategoryComponent } from './components/topline-tag-category/topline-tag-category.component';
import { ToplinesDisplayComponent } from './components/toplines-display.component';

const DIRECTIVES = [
];

const COMPONENTS = [
  HighlightedToplineComponent,
  ToplinesDisplayComponent,
  ToplineAddressComponent,
  ToplinePhoneComponent,
  ToplineAgeComponent,
  ToplineEmailComponent,
  ToplineSocialComponent,
  ToplineTagCategoryComponent,
  ToplineConnectionComponent,
  ToplinePreferredLanguageComponent,
  ToplineNoteComponent
];

const DIALOGS = [
];

const FORMS = [
];

@NgModule({
    imports: [
        SharedModule,
        NoteModule,
        ConnectionTypesSharedModule
    ],
    declarations: [
        ...DIRECTIVES,
        ...FORMS,
        ...COMPONENTS,
        ...DIALOGS
    ],
    providers: [],
    exports: [
        ...DIRECTIVES,
        ...FORMS,
        ...COMPONENTS,
        ...DIALOGS
    ]
})
export class ToplinesModule { }
